import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
// Helper component for animated numbers
const AnimatedNumber = ({
  value,
  suffix = ''
}: {
  value: number;
  suffix?: string;
}) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  useEffect(() => {
    if (isInView) {
      let start = 0;
      const duration = 2000; // 2 seconds
      const increment = value / (duration / 16); // 60fps
      const timer = setInterval(() => {
        start += increment;
        if (start >= value) {
          setCount(value);
          clearInterval(timer);
        } else {
          setCount(Math.floor(start));
        }
      }, 16);
      return () => clearInterval(timer);
    }
  }, [isInView, value]);
  return <span ref={ref} className="text-4xl md:text-5xl font-bold font-serif text-white" data-id="element-283">
      {count}
      {suffix}
    </span>;
};
export function StatsSection() {
  const stats = [{
    label: 'Publications',
    value: 175,
    suffix: '+'
  }, {
    label: 'Graduated',
    value: 56,
    suffix: '+'
  }, {
    label: 'Research Projects',
    value: 15,
    suffix: ''
  }, {
    label: 'Current Students',
    value: 14,
    suffix: ''
  }, {
    label: 'Research Funding',
    value: 10,
    suffix: 'Cr+',
    prefix: '₹'
  }, {
    label: 'Collaborators',
    value: 17,
    suffix: ''
  }];
  return <section className="py-20 bg-[#800000] relative overflow-hidden" data-id="element-284">
      {/* Decorative background pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-285">
        <div className="absolute inset-0" style={{
        backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
        backgroundSize: '30px 30px'
      }} data-id="element-286"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-287">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-y-12 gap-x-8 text-center" data-id="element-288">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col items-center" data-id="element-289">
              <div className="flex items-baseline justify-center" data-id="element-290">
                {stat.prefix && <span className="text-3xl md:text-4xl font-bold font-serif text-white mr-1" data-id="element-291">
                    {stat.prefix}
                  </span>}
                <AnimatedNumber value={stat.value} suffix={stat.suffix} data-id="element-292" />
              </div>
              <span className="mt-3 text-sm md:text-base font-medium text-white/80 uppercase tracking-wider" data-id="element-293">
                {stat.label}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}